import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Activity } from "lucide-react";
import { LanguageSelector } from "@/components/LanguageSelector";
import { useLanguage } from "@/context/LanguageContext";

const BG =
  "https://images.unsplash.com/photo-1710438399422-2fca27686bcd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGx1eHVyeSUyMGRhcmslMjB0ZXh0dXJlfGVufDB8fHx8MTc4NzI4MzE2NHww&ixlib=rb-4.1.0&q=85";

export const AuthShell = ({ overline, title, subtitle, children }) => {
  const { t } = useLanguage();
  // As páginas de acesso são sempre escuras, independentemente do tema do utilizador.
  useEffect(() => {
    const root = document.documentElement;
    const wasLight = root.classList.contains("light");
    root.classList.remove("light");
    return () => { if (wasLight) root.classList.add("light"); };
  }, []);

  return (
  <div className="min-h-screen bg-[#0B0C10] lg:grid lg:grid-cols-[1.1fr_1fr]">
    <div className="relative hidden overflow-hidden border-r border-[#22252F] lg:block">
      <img src={BG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
      <div className="absolute inset-0 bg-[#0B0C10]/70" />
      <div className="relative z-10 flex h-full flex-col justify-between p-14">
        <Link to="/login" className="flex items-center gap-3" data-testid="brand-logo">
          <span className="flex h-9 w-9 items-center justify-center rounded-md border border-[#2563EB]/50 bg-[#2563EB]/10">
            <Activity className="h-4 w-4 text-[#60A5FA]" />
          </span>
        </Link>

        <div className="max-w-md space-y-6">
          <h2 className="font-heading text-4xl font-light leading-tight tracking-tight text-white [text-shadow:0_2px_20px_rgba(0,0,0,0.6)]">
            {t("auth.tagline")}
          </h2>
          <p className="text-base text-[#94A3B8] md:text-lg">{t("auth.taglineSub")}</p>
          <div className="grid grid-cols-2 gap-3 font-mono text-xs text-[#94A3B8]">
            {["CRYPTO", "STOCKS", "FOREX", "COMMODITIES", "INDICES"].map((m) => (
              <span key={m} className="border border-[#22252F] bg-[#12141A]/70 px-3 py-2 backdrop-blur-xl">
                {m}
              </span>
            ))}
          </div>
        </div>

        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#4B5563]">
          {t("auth.footer")}
        </p>
      </div>
    </div>

    <div className="relative flex min-h-screen items-center justify-center px-6 py-16 sm:px-12">
      <div className="absolute right-6 top-6" data-testid="auth-language-switch">
        <LanguageSelector testId="auth-language-selector" />
      </div>
      <div className="w-full max-w-md">
        <div className="mb-10 space-y-3">
          <p className="text-xs uppercase tracking-[0.2em] text-[#60A5FA]">{overline}</p>
          <h1 className="font-heading text-4xl font-light tracking-tight text-white sm:text-5xl">{title}</h1>
          <p className="text-sm text-[#94A3B8]">{subtitle}</p>
        </div>
        {children}
      </div>
    </div>
  </div>
  );
};
